import { ENV } from 'evcharging/app';

export const createApiBaseUrl = (): string => ENV.API_BASE_URL;
export const API_CONSUMER_NAME = 'energy5-webapp';
export const HEADER_PAGINATION_TOTAL_ELEMENTS = 'pagination-total-elements';
export const BROKER_ID = '515df4ca-fd89-455a-96c6-840f1ac712bc';
